import { motion } from 'framer-motion';

export const POSES = {
  happy: '/assets/characters/piko_happy.webp',
  think: '/assets/characters/piko_think.webp',
  celebrate: '/assets/characters/piko_celebrate.webp',
  sleep: '/assets/characters/piko_sleep.webp',
  eat: '/assets/characters/piko_eat.webp',
  point: '/assets/characters/piko_point.webp',
};

export function Piko({ pose = 'happy', size = 150, className = '', float = true }) {
  return (
    <motion.div
      animate={float ? { y: [0, -8, 0] } : {}}
      transition={{ repeat: Infinity, duration: 4, ease: 'easeInOut' }}
      className={`inline-block ${className}`}
      data-testid="piko-mascot">
      <img src={POSES[pose] || POSES.happy} alt="Piko" draggable={false}
        style={{ width: size, height: size, objectFit: 'cover', borderRadius: '38%',
          border: '6px solid rgba(255,255,255,0.85)', boxShadow: '0 12px 28px rgba(29,53,87,0.22)' }}
        className="select-none pointer-events-none bg-cream" />
    </motion.div>
  );
}
